<div class="bg-white">
  <textarea
    name="ir1"
    id="ir1"
    rows="10"
    cols="100"
    [style]="{ height: height(), display: 'none' }"
    >{{ updateContent() }}</textarea
  >
</div>
